import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC013_Request,
  IAPI_ACC013_Response,
} from "../../../type/apiType";

// 退職者情報登録
// API仕様書_アカウント管理
const httpAPI_ACC013 = async (
  param: IAPI_ACC013_Request
): Promise<IAPI_ACC013_Response> => {
  let res = await http.post(ApiUrl.API_ACC013, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC013 };
